import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 575;

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
    isMobile: width <= MOBILE_BREAKPOINT,
    isDesktop: width > MOBILE_BREAKPOINT,
  };
}

export const useWindowDimensions = () =>  {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
